import { format, date } from "../utils";

const Format = ({
  value,
  type = 'currency',
  compact = 'normal',
  currency,
  locale
}) => {
  if (type === 'date') {
    return date(value, compact);
  }

  if (type === 'number') {
    return value < 0 ? `(${Math.abs(value)})` : value;
  }

  return format(value, compact, currency, 2, locale);
};

export default Format;